/** mgt's person card is 340px wide unless styled otherwise; used until the card has a measured width. */
export const CARD_WIDTH = 340;

const EDGE_MARGIN = 8;

/**
 * Centre the card over the mention, but keep it on screen. Centred alone, a mention near either edge
 * pushed the card past it - on a phone, a mention in a right-aligned comment bubble lost the card's
 * right side (#35350).
 */
export const getCardLeft = (
  rect: Pick<DOMRect, 'left' | 'width'>,
  cardWidth: number,
  viewportWidth: number
): number => {
  const centred = rect.left + rect.width / 2 - cardWidth / 2;
  const maxLeft = viewportWidth - cardWidth - EDGE_MARGIN;
  return Math.max(EDGE_MARGIN, Math.min(centred, maxLeft));
};
